export const countryCodes = [
    { iso: 'UAE', dialCode: '+971' },
    { iso: 'IND', dialCode: '+91' },
    { iso: 'USA', dialCode: '+1' },
    { iso: 'GBR', dialCode: '+44' },
    { iso: 'SAU', dialCode: '+966' },
    { iso: 'QAT', dialCode: '+974' },
    { iso: 'KWT', dialCode: '+965' },
    { iso: 'BHR', dialCode: '+973' },
    { iso: 'OMN', dialCode: '+968' },
    { iso: 'PAK', dialCode: '+92' },
    { iso: 'BGD', dialCode: '+880' },
    { iso: 'LKA', dialCode: '+94' },
    { iso: 'NPL', dialCode: '+977' },
    { iso: 'AFG', dialCode: '+93' },
    { iso: 'CAN', dialCode: '+1' },
    { iso: 'AUS', dialCode: '+61' },
    { iso: 'NZL', dialCode: '+64' },
    { iso: 'DEU', dialCode: '+49' },
    { iso: 'FRA', dialCode: '+33' },
    { iso: 'ITA', dialCode: '+39' }
];

export const getDialCode = (iso) =>
    countryCodes.find((country) => country.iso === iso)?.dialCode || '+971';
